import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PPSICreate from './PumpSpareInternational/Create';
import PRAMDCreate from './AraiManufacturing/Create';

function PRCreate() {
  const [purchasereturnType, setPurchasereturnType] = useState('');
  const [purchasereturnCategory, setPurchasereturnCategory] = useState('');
  const [typeDisabled, setTypeDisabled] = useState(false);
  const [categoryDisabled, setCategoryDisabled] = useState(false);

  const handleTypeChange = (e) => {
    const type = e.target.value;
    setPurchasereturnType(type);
    setPurchasereturnCategory(''); // reset category when type changes
    setCategoryDisabled(false); // enable category selection

    // For Manufacturing and Pump Spare, auto set category and disable category select
    if (type === 'Manufacturing') {
      setPurchasereturnCategory('Domestic');
      setCategoryDisabled(true);
    } else if (type === 'Pump Spare') {
      setPurchasereturnCategory('International');
      setCategoryDisabled(true);
    }

    // Disable type select after selection
    setTypeDisabled(true);
  };

  const handleCategoryChange = (e) => {
    setPurchasereturnCategory(e.target.value);
    setCategoryDisabled(true);
  };

  const renderPageDisplay = () => {
    if (purchasereturnType === 'Pump Spare' && purchasereturnCategory === 'International') {
      return <PPSICreate />;
    } else if (purchasereturnType === 'Manufacturing') {
      return <PRAMDCreate />;
    }
    return null;
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>ADD PURCHASE RETURN</h6>
          <Link to="/prindex/1">
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Type:</Form.Label>
                <Form.Select
                  onChange={handleTypeChange}
                  value={purchasereturnType}
                  disabled={typeDisabled}
                >
                  <option value="">--Please choose an option--</option>
                  {/* Tubing option removed */}
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {purchasereturnType === 'Pump Spare' && (
              <Col md="6">
                <Form.Group>
                  <Form.Label>PO Category:</Form.Label>
                  <Form.Control value="International" disabled />
                </Form.Group>
              </Col>
            )}

            {purchasereturnType === 'Manufacturing' && (
              <Col md="6">
                <Form.Group>
                  <Form.Label>PO Category:</Form.Label>
                  <Form.Control value="Domestic" disabled />
                </Form.Group>
              </Col>
            )}

            {renderPageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default PRCreate;
